import parser from './parser';

const dataSet = (tableName, dataList) => {
  let headers = [];
  let widths = [];
  let rows = [];

  if (dataList) {
    switch(tableName) {
      case 'PaymentsAdmin':
        headers = [
          "Orden", "Serie", "Nº Fact.", "Siniestro", "Fecha Solicitado", 
          "Rut", "Razón Social", "Total", "Estado", "Tipo"
        ];
        widths = [18,18,18,18,18,18,30,18,28,18];
        rows = dataList.map(d => {
          let paymentState = d.paymentState ? parser('STATE', d.paymentState) : '';
          if (d.paymentState === "PROCESSED") {
            paymentState = paymentState + ' - ' + d.paymentComment;
          }
          return [
          d.purchaseOrderId,
          d.voucherSeries,
          d.invoiceNumber,
          d.sinisterNumber,
          parser('DATE', d.date.toString()),
          d.providerRut,
          d.providerName,
          d.amount ? parser('UYU', d.amount) : null,
          paymentState,
          parser('TYPE', d.isElectronic)
        ]});
        break;
      case 'OrdersAdmin':
        headers = [
          "Orden", "Siniestro", "Fecha", 
          "Razón Social", "Rut", "Diferencia", "Estado"
        ];
        widths = [18,18,18,30,18,18,28];
        rows = dataList.map(d => [
          d.orderId,
          d.sinisterNumber,
          parser('DATE', d.date.toString()),
          d.socialName,
          d.rut,
          d.diff ? parser('UYU', -d.diff) : null,
          d.orderState ? parser('STATE', d.orderState) : ''
        ]);
        break;
      case 'OrdersUser':
        headers = [
          "Orden", "Siniestro", "Fecha", 
          "Importe", "Diferencia", "Estado"
        ];
        widths = [18,18,18,18,18,25];
        rows = dataList.map(d => [
          d.orderId,
          d.sinisterNumber,
          parser('DATE', d.date.toString()),
          d.amount ? parser('UYU', d.amount) : null,
          d.invoicesInfo && d.invoicesInfo.showDiff ? 
            parser('UYU', -d.invoicesInfo.diff) : null,
            d.state ? parser('STATE', d.state) : ''
        ]);
        break;
      case 'AssociatedInvoices':
        headers = [
          "Orden", "Serie", "Nº Fact.", "Siniestro", "Fecha Factura", 
          "Fecha Solicitado", "Total", "Estado", "Tipo"
        ];
        widths = [18,18,18,18,18,18,18,28,18];
        rows = dataList.map(d => {

          let paymentState = d.paymentState ? parser('STATE', d.paymentState) : '';
          if (d.paymentState === "PROCESSED") {
            paymentState = paymentState + ' - ' + d.paymentComment;
          }

          return [
          d.purchaseOrderId,
          d.voucherSeries,
          d.invoiceNumber,
          d.sinisterNumber,
          parser('DATE', d.date.toString()),
          d.requestedPayment ? 
            parser('DATE', d.requestedPaymentDate.toString()) : 
            'No Solicitado',
          d.amount ? parser('UYU', d.amount) : null,
          paymentState,
          parser('TYPE', d.isElectronic)
        ]});
        break;
      case 'AccountStatement':
        headers = [
          "Serie", "Nº Fact.", "Fecha Factura", 
          "Orden", "Siniestro", 
          "Importe", "Estado", "Tipo"
        ];
        widths = [18,18,18,18,18,18,28,18];
        rows = dataList.map(d => {

          let paymentState = d.paymentState ? parser('STATE', d.paymentState) : '';
          if (d.paymentState === "PROCESSED") {
            paymentState = paymentState + ' - ' + d.paymentComment;
          }

          return [
          d.voucherSeries,
          d.invoiceNumber,
          parser('DATE', d.date.toString()),
          d.purchaseOrderId,
          d.sinisterNumber,
          d.amount ? parser('UYU', d.amount) : null,
          paymentState,
          parser('TYPE', d.isElectronic)
        ]});
        break;
      default:
    }
  }
  return {headers, widths, rows};
}

export default dataSet;